import { useUiPreferences } from '@/stores/uiPreferences';
import { formatBRL, formatSignedBRL, MASKED_BRL, MASKED_PCT } from './money';

export function useMoneyFormat() {
  const hidden = useUiPreferences((s) => s.hideMoney);
  return {
    hidden,
    fmt: (cents: number) => (hidden ? MASKED_BRL : formatBRL(cents)),
    fmtSigned: (cents: number, type: 'income' | 'expense') =>
      hidden ? MASKED_BRL : formatSignedBRL(cents, type),
    fmtPct: (pct: number, signed = false) => {
      if (hidden) return MASKED_PCT;
      const value = `${pct.toFixed(1)}%`;
      if (!signed) return value;
      return `${pct >= 0 ? '+' : ''}${value}`;
    },
  };
}
